namespace Gamification.Gamification {
    export interface ProdottiEsperienzeTaskRow {
        IdProdottoEsperienzaTask?: number;
        IdProdottoEsperienza?: number;
        IdentifierTask?: string;
        Nome?: string;
        Descrizione?: string;
        IdProdottoEsperienzaIdProdotto?: number;
        IdProdottoEsperienzaIdentifierEsperienza?: string;
        IdProdottoEsperienzaNome?: string;
        IdProdottoEsperienzaDescrizione?: string;
        IdProdottoEsperienzaBozza?: number;
    }

    export namespace ProdottiEsperienzeTaskRow {
        export const idProperty = 'IdProdottoEsperienzaTask';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.ProdottiEsperienzeTask';
        export const lookupKey = 'Gamification.ProdottiEsperienzeTask';

        export function getLookup(): Q.Lookup<ProdottiEsperienzeTaskRow> {
            return Q.getLookup<ProdottiEsperienzeTaskRow>('Gamification.ProdottiEsperienzeTask');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            IdProdottoEsperienzaTask = "IdProdottoEsperienzaTask",
            IdProdottoEsperienza = "IdProdottoEsperienza",
            IdentifierTask = "IdentifierTask",
            Nome = "Nome",
            Descrizione = "Descrizione",
            IdProdottoEsperienzaIdProdotto = "IdProdottoEsperienzaIdProdotto",
            IdProdottoEsperienzaIdentifierEsperienza = "IdProdottoEsperienzaIdentifierEsperienza",
            IdProdottoEsperienzaNome = "IdProdottoEsperienzaNome",
            IdProdottoEsperienzaDescrizione = "IdProdottoEsperienzaDescrizione",
            IdProdottoEsperienzaBozza = "IdProdottoEsperienzaBozza"
        }
    }
}
